import '../static/FlyingMenu.css';
import React__default, { useState, useCallback, useEffect } from "react";
import clsx from "clsx";
import { P as Popover } from "./Popover.DkgLMtxz.mjs";
import { b as Paragraph } from "./Paragraph.DAcb0zW2.mjs";
const list = `_list_e70a268`;
const selected = `_selected_22a78ee`;
const focused = `_focused_ab284fa`;
const content = `_content_61da709`;
const styles = { list, selected, focused, content };
function getFlyingMenuItemId(id, index) {
  return `${id}-item-${index}`;
}
const FlyingMenu = ({
  anchorRef,
  defaultSelected = -1,
  id = "ui-flying-menu",
  children,
  onChange = () => {
  },
  onClose,
  open,
  itemRole = "menuitem",
  role = "menu",
  ...props
}) => {
  var _a;
  const [focusedIndex, setfocusedIndex] = useState(-1);
  const [selectedIndex, setSelectedIndex] = useState(defaultSelected);
  const handleClose = useCallback(() => {
    setfocusedIndex(-1);
    const anchorEl = anchorRef.current;
    if (!anchorEl)
      return;
    anchorEl.removeAttribute("aria-activedescendant");
    onClose();
  }, [anchorRef, onClose]);
  const handleChange = useCallback(
    (index) => {
      setSelectedIndex(index);
      onChange(index);
      handleClose();
      const anchorEl = anchorRef.current;
      if (!anchorEl || index < 0) {
        return;
      }
    },
    [anchorRef, handleClose, onChange]
  );
  const handleFocus = useCallback(
    (index) => {
      setfocusedIndex(index);
      const anchorEl = anchorRef.current;
      if (!anchorEl || index < 0) {
        return;
      }
      anchorEl.setAttribute(
        "aria-activedescendant",
        getFlyingMenuItemId(id, index)
      );
    },
    [anchorRef, id]
  );
  const handleKeydown = useCallback(
    (event) => {
      if (!children)
        return;
      let currentIndex = focusedIndex;
      const childrenAsArray = children;
      switch (event.key) {
        case "ArrowUp":
        case "Up":
          event.preventDefault();
          if (focusedIndex > 0) {
            currentIndex = focusedIndex - 1;
          } else {
            currentIndex = childrenAsArray.length - 1;
          }
          handleFocus(currentIndex);
          break;
        case "ArrowDown":
        case "Down":
          event.preventDefault();
          if (focusedIndex < childrenAsArray.length - 1) {
            currentIndex = focusedIndex + 1;
          } else {
            currentIndex = 0;
          }
          handleFocus(currentIndex);
          break;
        case "Home":
          if (!open)
            return;
          event.preventDefault();
          currentIndex = 0;
          handleFocus(currentIndex);
          break;
        case "End":
          if (!open)
            return;
          event.preventDefault();
          currentIndex = childrenAsArray.length - 1;
          handleFocus(currentIndex);
          break;
        case "Enter":
        case "Space":
          event.preventDefault();
          handleChange(currentIndex);
          break;
      }
    },
    [focusedIndex, open]
  );
  useEffect(() => {
    const anchorEl = anchorRef.current;
    if (!anchorEl) {
      return;
    }
    anchorEl.addEventListener("keydown", handleKeydown);
    return () => {
      anchorEl.removeEventListener("keydown", handleKeydown);
    };
  }, [anchorRef, handleKeydown]);
  return /* @__PURE__ */ React__default.createElement(
    Popover,
    {
      ...props,
      anchorRef,
      "aria-labelledby": (_a = anchorRef == null ? void 0 : anchorRef.current) == null ? void 0 : _a.id,
      id,
      role,
      onClose: handleClose,
      open
    },
    React__default.Children.map(children, (child, index) => /* @__PURE__ */ React__default.createElement(
      Paragraph,
      {
        as: "li",
        size: "sm",
        className: clsx(styles.list, {
          [styles.focused]: focusedIndex === index,
          [styles.selected]: selectedIndex === index
        }),
        onMouseDown: (e) => {
          e.preventDefault();
        },
        onClick: () => handleChange(index)
      },
      React__default.cloneElement(child, {
        className: clsx(child.props.className, styles.content),
        role: itemRole,
        tabIndex: -1,
        id: getFlyingMenuItemId(id, index),
        "aria-selected": selectedIndex === index
      })
    ))
  );
};
export {
  FlyingMenu as F,
  getFlyingMenuItemId as g
};
//# sourceMappingURL=FlyingMenu.DB9naeeI.mjs.map
